import { ViewModel,View, Component, ObservableArray } from "binder"
import  { SidebarView } from "./sidebar-view"
import { SidebarItemViewModel } from "./sidebarItem/sidebarItem-viewModel";

export class SidebarViewModel extends Component implements ISidebarActivationRemover{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.internalItems = ObservableArray.create<SidebarItemViewModel>();
    }
    
    GetDefaultView(): View <ViewModel> {
        return new SidebarView();
    }
    public getTypeId(): string {
        return "VM-9BD719B8-804A-4944-A562-83ED1F9267E9"
    }

    public set items(v: SideBarItem[]) { 
        this._items = v; 
        this.internalItems.clear();
        if(v){
            v.forEach(x=>this.parseItems(x,this.internalItems,this));
        }
    } public get items(): SideBarItem[] { return this._items;} private _items: SideBarItem[];
    public set internalItems(v: ObservableArray<SidebarItemViewModel>) { this._internalItems = v; } public get internalItems(): ObservableArray<SidebarItemViewModel> { return this._internalItems;} private _internalItems: ObservableArray<SidebarItemViewModel>;
    
    parseItems(item:SideBarItem,resultList:ObservableArray<SidebarItemViewModel>,parent:ViewModel){
        var result = new SidebarItemViewModel(parent);
        result.className = item.iconClass;
        result.name = item.name;
        result.command = item.command;
        (item.childItems ?? []).forEach(element => {
            this.parseItems(element,result.children,result);
        });
        resultList.push(result);
    }

    onItemActivated(item: SidebarItemViewModel) {
        this.internalItems.forEach(x=>{
            if(x!=item)
                x.deactivate();
        })
    }
}

export interface SideBarItem{
    name:string,
    iconClass:string;
    command:()=>void;
    childItems:SideBarItem[];
}

export interface ISidebarActivationRemover{
    onItemActivated(item:SidebarItemViewModel);
}